import {
    CREATE_MODULE,
    TOGGLE_MODULE,
    SET_NUMBER_OF_ITEMS,
} from "../actions";

const module = (state = [], action) => {
    switch (action.type) {
    case CREATE_MODULE:
        return {
            internalId: action.internalId,
            id: action.id,
            moduleType: action.moduleType,
            name: action.name,
            label: action.label,
            labelType: action.labelType,
            amount: action.amount,
            description: action.description,
            readMoreLink: action.readMoreLink,
            bundlePrice: action.bundlePrice,
            nonBundlePrice: action.nonBundlePrice,
            bundleQuantity: action.bundleQuantity,
            numberOfItems: action.numberOfItems,
            active: action.active,
        };
    case TOGGLE_MODULE:
        return (state.moduleType === action.moduleType)
            ? { ...state, active: action.active }
            : state;
    case SET_NUMBER_OF_ITEMS:
        return (state.moduleType === action.moduleType)
            ? { ...state, numberOfItems: action.numberOfItems }
            : state;
    default:
        return state
    }
}

const modules = (state = [], action) => {
    switch (action.type) {
    case CREATE_MODULE:
        if (state.some(_module => _module.moduleType === action.moduleType)) {
            return state;
        }

        return [
            ...state,
            module(undefined, action)
        ];
    case TOGGLE_MODULE:
        return state.map((_module) => module(_module, action));
    case SET_NUMBER_OF_ITEMS:
        return state.map((_module) => module(_module, action));
    default:
        return state;
    }
};

export default modules;
